import { render, staticRenderFns } from "./codes-references.vue?vue&type=template&id=18cf8fc4&scoped=true&"
import script from "./codes-references.vue?vue&type=script&lang=js&"
export * from "./codes-references.vue?vue&type=script&lang=js&"
import style0 from "./codes-references.vue?vue&type=style&index=0&id=18cf8fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf8fc4",
  null
  
)

export default component.exports